module.exports = __webpack_public_path__ + "img/6.8ff81ec2.jpg";